/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable func-names */
import React, { useState, useRef, useEffect } from 'react';
import { usePostHog } from '@posthog/react';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import CameraIcon from '@material-ui/icons/PhotoCamera';
import CheckIcon from '@material-ui/icons/Check';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import VideoRecorder from 'react-video-recorder';
import { isCreditCard } from 'validator';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import Axios from 'axios';
import { get, isEmpty, filter, toLower, includes, head, find } from 'lodash';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Numeral from 'numeral';
import parse from 'html-react-parser';
import 'moment/locale/es';
import { Buffer } from 'buffer';
import LogRocket from 'logrocket';
import { isIOS } from 'mobile-device-detect';
import { CloudUpload } from '@material-ui/icons';

import {
  Card,
  CardContent,
  RadioGroup,
  useMediaQuery,
} from '@material-ui/core';
import moment from 'moment';
import SignatureCanvas from 'react-signature-canvas';

import { createUrlForSrc, media } from '../../utils/helper';
import VideoActions from './videoActions';
import DomicilioActual from './DomicilioActual';
import Loader from '../../components/Loader';

import config from '../../config';

import {
  Content,
  ContainerCard,
  NavBarContainer,
  Input,
  LoadingLabel,
  ContainerGeneral,
  ContentButonGroup,
  ContentButon,
  ContentDialog,
  ContainerData,
  ButtonGrupDialog,
  ContentTerms,
  ContainerDialogTerms,
  ImageContainer,
  DocumentContainer,
  ImageDocumentContainer,
  ReplaceImageButton,
  DistributorImage,
  DocumentText,
  FileUploadContainer,
  InputSelfieContainer,
  ContainerCanvas,
  BeneficiosList,
} from './styledComponents';
import BeneficiariosForm from '../../components/BeneficiariosForm';
import CoaseguradosForm from '../../components/CoaseguradosForm';
window.Buffer = window.Buffer || Buffer;

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const options = {
  // eslint-disable-next-line consistent-return
  replace: domNode => {
    if (domNode.attribs && domNode.attribs.class === 'remove') {
      return <></>;
    }
  },
};

const TextMaskCustom = props => {
  const { inputRef, placeholder, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        /[4-5]/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={'\u2000'}
      placeholder={placeholder}
    />
  );
};

TextMaskCustom.propTypes = {
  inputRef: PropTypes.any.isRequired,
  placeholder: PropTypes.string.isRequired,
};

function urltoFile(url, filename, mimeType) {
  return fetch(url)
    .then(function(res) {
      return res.arrayBuffer();
    })
    .then(function(buf) {
      return new File([buf], filename, { type: mimeType });
    });
}

const CanjeValeDigital = props => {
  const banksOptionsRef = useRef(null);
  const signatureRef = useRef(null);
  const requierePagareDigital = useRef(null);
  const numeroIntentosValidacionComprobanteDomicilio = useRef(null);
  const requiereComprobanteDom = useRef(null);
  const plazaRequiereComprobanteDom = useRef(null);
  const documentoClienteValidado = useRef(null);
  const documentoClienteId = useRef(null);

  const [signature, setSignature] = useState(null);
  const [cambiaFirma, setCambiaFirma] = useState(false);
  const [pagareTemplate, setPagareTemplate] = useState('');

  // const [banksOptions, setBanksOptions] = useState([]); // TODO: Delete
  const [parentescoOptions, setParentescoOptions] = useState([]);
  const [parentescosCoaseguradosOpt, setParentescosCoaseguradosOpt] = useState(
    [],
  );
  const [coasegurados, setCoasegurados] = useState([]);

  const [activeStep, setActiveStep] = React.useState(0);

  const [cancelVaucher, setCancelVaucher] = useState(false);

  const [termsAgreed, setTermsAgreed] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState('');
  const [identityValidationAttempts, setIdentityValidationAttempts] = useState(
    0,
  );
  const [validationAttempt, setValidationAttempt] = useState('');
  const [errorSelfie, setErrorSelfie] = useState('');
  const [termsAgreedOpen, setTermsAgreedOpen] = useState(false);

  const [fileUploaded, setFileUploaded] = useState(null);

  const [videoIdentity, setVideo] = useState(null);

  const [editCard, setEditCard] = useState(false);
  const [cardTouched, setCardTouched] = useState(false);
  const [card, setCard] = useState('');

  const [notFound, setNotFound] = useState('');
  const [loading, setLoading] = useState(true);
  const [confirmCardTouched, setConfirmCardTouched] = useState(false);
  const [confirmCard, setConfirmCard] = useState('');

  const [errorText, setErrorText] = useState('');
  const [inputsDisabled, setInputsDisabled] = useState(false);

  const token = get(props, 'match.params.token', '');
  const [alreadyUsed, setAlreadyUsed] = useState('');
  const [lastDigits, setLastDigits] = useState('');
  const [bank, setBank] = useState('');
  const [newBank, setNewBank] = useState('');

  const [clientInfo, setClientInfo] = useState(null);
  const [loadingFull, setLoadingFull] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [successText, setSuccessText] = useState('');
  const [valeCanjeado, setValeCanjeado] = useState('');

  const [showIdentityValidator, setShowIndentityValidator] = useState(true);
  // const [showVideoCapturer, setShowVideoCapturer] = useState(false);

  const [voucherRedeemed, setVaucherRedeemed] = useState(false);

  const [postalCode, setPostalCode] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [suburb, setSuburb] = useState('');
  const [suburbsOptions, setSuburbsOptions] = useState([]);
  const [street, setStreet] = useState('');
  const [number, setNumber] = useState('');

  const [addressFromProof, setAddressFromProof] = useState(false);
  const [newPostalCode, setNewPostalCode] = useState('');
  const [newCity, setNewCity] = useState('');
  const [newState, setNewState] = useState('');
  const [newSuburb, setNewSuburb] = useState('');
  const [newStreet, setNewStreet] = useState('');
  const [newNumber, setNewNumber] = useState('');

  const [startExchange, setStartExchange] = useState(false);
  const [editAddress, setEditAddress] = useState(false);
  const [existAddress, setExistAddress] = useState(false);
  const [existCard, setExistCard] = useState(null);

  const [myBankName, setMyBankName] = useState('');

  const [confirmCancelVaucher, setConfirmCancelVaucher] = useState(false);

  const [coaseguradosCopy, setCoaseguradosCopy] = useState([]);
  const [editCoasegurados, setEditCoasegurados] = useState(false);
  const [validCoasegurados, setValidCoasegurados] = useState(false);

  const [beneficiarios, setBeneficiarios] = useState([
    {
      id: null,
      nombre: '',
      fechaNacimiento: new Date(),
      parentescoId: '',
      porcentaje: 100,
    },
  ]);
  const [beneficiariosCopy, setBeneficiariosCopy] = useState([]);
  const [editBeneficiarios, setEditBeneficiarios] = useState(false);
  const [validBeneficiarios, setValidBeneficiarios] = useState(false);

  const [seguroOptions, setSeguroOptions] = useState([]);
  const [seguroSelected, setSeguroSelected] = useState(null);

  const [ineFrente, setIneFrente] = useState('');
  const [ineReverso, setIneReverso] = useState('');
  const [alreadyIdCapture, setAlreadyIdCapture] = useState(true);
  const [alreadyIdCaptureError, setAlreadyIdCaptureError] = useState(false);
  const [selfie, setSelfie] = useState(null);
  const [alreadyFaceCapture, setAlreadyFaceCapture] = useState(false);
  const [errorFaceCapture, setErrorFaceCapture] = useState(false);
  const [tokenNubarium, setTokenNubarium] = useState();
  const [currentlyFaceCapture, setCurrentlyFaceCapture] = useState(false);
  const [currentlyIdCapture, setCurrentlyIdCapture] = useState(false);
  const [successSelfie, setSuccessSelfie] = useState('');
  const [userBlockGeolocation, setUserBlockGeolocation] = useState(false);
  const [actualizarTarjeta, setActualizarTarjeta] = useState();
  const transferenciaStpRejected = useRef(null);
  const tarjetaRejected = useRef(null);
  const bancoIdRejected = useRef(null);

  // NOTE: Domicilio Actual
  const [addressProofFile, setAddressProofFile] = useState();
  const [addressProofFileName, setAddressProofFileName] = useState();

  // eslint-disable-next-line prefer-const
  let latitudRef = useRef(null);
  // eslint-disable-next-line prefer-const
  let longitudRef = useRef(null);

  const [ineFront, setIneFront] = useState(null);
  const [ineBack, setIneBack] = useState(null);
  const [ineFrontUrl, setIneFrontUrl] = useState(null);
  const [ineBackUrl, setIneBackUrl] = useState(null);

  const isMobile = useMediaQuery(media.medium);

  const posthog = usePostHog();
  // arreglo con los eventos de posthog que ya fueron capturados esta sesión
  const [capturados, setCapturados] = useState([]);

  /**
   * @param {string} stringBase64 String Base64 de la Imagen
   * @param {string} fileName Nombre del Archivo
   * @returns {Promise<File>}
   */
  const compressImage = async (stringBase64, fileName) => {
    const img = new Image();
    img.src = `data:image/png;base64,${stringBase64}`;

    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = error =>
        reject(new Error(`Failed to load image: ${error.message}`));
    });

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;

    ctx.drawImage(img, 0, 0);

    // Compress the image to JPEG with a lower quality (e.g., 0.7 for 70% quality)
    const desiredQuality = 0.7; // Adjust this value for more or less compression
    const outputMimeType = 'image/jpeg';

    const blob = await new Promise(resolve => {
      canvas.toBlob(resolve, outputMimeType, desiredQuality);
    });

    if (!blob) {
      throw new Error('Failed to compress image: Blob creation failed.');
    }

    const compressedSelfieFile = new File([blob], `${fileName}.jpeg`, {
      type: outputMimeType,
      lastModified: Date.now(),
    });

    return compressedSelfieFile;
  };

  const onSignatureEnd = () => {
    const signatureEl = signatureRef.current;
    if (!signatureEl.isEmpty()) {
      setCambiaFirma(true);
      setSignature(signatureEl.toDataURL());
    }
  };

  const clearSignature = () => {
    const signatureEl = signatureRef.current;
    signatureEl.clear();
    setSignature(null);
  };

  const guardarFirma = async () => {
    try {
      setLoadingFull(true);
      const formData = new FormData();
      const base64Response = await fetch(signature);
      const blob = await base64Response.blob();
      const firmaFile = new File([blob], 'firma.png', { type: 'image/png' });
      const clienteId = get(clientInfo, 'clienteId', '');
      const valeId = get(clientInfo, 'id', '');
      formData.append('firma', firmaFile);
      await Axios.patch(
        `${config.api.url}/clientes/subirFirma?clienteId=${clienteId}&valeId=${valeId}`,
        formData,
      );
    } catch (e) {
      setErrorText('Error al subir imagen de la firma del cliente');
    } finally {
      setLoadingFull(false);
      setSuccessText('Firma enviada con éxito');
    }
  };

  // NOTE: Asigna la firma del cliente al canvas
  // const fetchFirma = async firmaDigital => {
  //   const base64 = await fetch(firmaDigital)
  //     .then(response => response.blob())
  //     .then(blob => {
  //       const reader = new FileReader();
  //       reader.readAsDataURL(blob);
  //       return new Promise(res => {
  //         reader.onloadend = () => {
  //           res(reader.result);
  //         };
  //       });
  //     });
  //   const signatureEl = signatureRef.current;
  //   if (!isEmpty(signatureEl)) {
  //     signatureEl.fromDataURL(base64);
  //     setSignature(firmaDigital);
  //     setCambiaFirma(false);
  //   }
  // };

  const IdComponent = () => {
    if (alreadyIdCapture) return <div />;
    try {
      // eslint-disable-next-line no-undef
      const idCapture = new IdCapture();

      // Initialize the component with your custom configuration
      const idCaptureConfig = {
        rootElement: 'id_component', // DOM Element that will contains the HTML Component
        maxValidations: 99,
        timeouts: {
          front: 180000,
          back: 180000,
        },
        captureMode: {
          front: {
            enabled: true,
            after: 0,
          },
          back: {
            enabled: true,
            after: 0,
          },
        },
        // Enable/Disable image guide
        guide: {
          front: {
            enabled: true, // Enable guide on front capture. (By default is enabled)
          },
          back: {
            enabled: true, // Enable guide on back capture. (By default is enabled)
            until: 10000,
          },
        },
        autorotate: true, // Automatic rotate the image to return a landscape image.
        antispoofing: {
          // Default values
          enabled: true,
          level: 10,
        },
      };

      // Set the JWT token
      // faceCapture.setToken(
      idCapture.setToken(tokenNubarium);
      // eslint-disable-next-line no-undef

      // faceCapture.init(nubariumConfig);
      idCapture.init(idCaptureConfig);

      idCapture.load(() => {
        // Once that the component is loaded then it will execute the following
        // If you requires to start the component automatically after load its recommend it to start the component.
        idCapture.start();
      });

      idCapture.onEvaluation((evaluation, result) => {
        const ev = evaluation; // success, fail
        // The result object is similar to the onSuccess or onFail.
      });
      idCapture
        .onSuccess(data => {
          setIneFrente(data.front);
          setIneReverso(data.back);
          setAlreadyIdCapture(true);
          setAlreadyIdCaptureError(false);

          setCurrentlyIdCapture(false);
          console.log('onSuccess', data);
          try {
            idCapture.clear();
            idCapture.close();
          } catch (e) {
            console.log(`Error from Nubarium: ${e}`);
          }
          // delete idCapture.instance;
        })
        .onFail(fail => {
          console.log('onFail', fail);
          // idCapture.retry();
          setAlreadyIdCaptureError(true);
          // NOTE: No sirve pero es lo mas cercano a que
          // funcione
          setTimeout(() => {
            // idCapture.close();
            // idCapture.retry();
            // idCapture.reset();
          }, 100);
        })
        .onError(error => {
          console.log('onError', error);
          const errorCode = error.code;
          const errorMsg = error.msg;
        });
    } catch (e) {
      console.log(e);
      return <div></div>;
    }

    // eslint-disable-next-line consistent-return
    return <div></div>;
  };

  const FaceComponent = () => {
    // eslint-disable-next-line no-undef
    const faceCapture = new FaceCapture();

    // Initialize the component with your custom configuration
    const faceCaptureConfig = {
      rootElement: 'face_component', // DOM Element that will contains the HTML Component
      maxValidations: 3,
      features: {
        // Optional
        disabled: ['glasses', 'facemask'], // Default values // Does not allow glasses and facemask
        enabled: [],
      },
      antispoofing: {
        // Default values
        enabled: true,
        level: 3,
      },
    };

    // Set the JWT token
    // faceCapture.setToken(
    faceCapture.setToken(tokenNubarium);
    // eslint-disable-next-line no-undef

    // faceCapture.init(nubariumConfig);
    faceCapture.init(faceCaptureConfig);

    faceCapture.load(() => {
      // Once that the component is loaded then it will execute the following
      // If you requires to start the component automatically after load its recommend it to start the component.
      faceCapture.start();
    });

    faceCapture.onEvaluation((evaluation, result) => {
      const ev = evaluation; // success, fail
      // The result object is similar to the onSuccess or onFail.
    });
    faceCapture
      .onSuccess(data => {
        console.log('onSuccess', data);
        setAlreadyFaceCapture(true);
        setCurrentlyFaceCapture(false);
        setSelfie(data.frame);
      })
      .onFail(fail => {
        console.log('onFail', fail);
        setTimeout(() => {
          faceCapture.retry();
          // idCapture.close();
          // idCapture.retry();
          // idCapture.reset();
        }, 100);
      })
      .onError(error => {
        console.log('onError', error);
        const errorCode = error.code;
        const errorMsg = error.msg;
      });

    return <div />;
  };

  // NOTE: Asigna la firma del cliente
  // useEffect(() => {
  //   if (activeStep === 5) {
  //     if (signature) fetchFirma(signature);
  //   }
  // }, [activeStep]);

  useEffect(() => {
    if (newPostalCode.length === 5 && editAddress) {
      fetchDataAddress();
    }
  }, [newPostalCode, editAddress]);

  // NOTE: Debug ActualizarTarjeta
  // useEffect(() => {
  //   console.log(confirmCard.replaceAll(' ', '') === lastDigits);
  // }, [confirmCard]);

  useEffect(() => {
    if (activeStep === 4 && !editAddress) {
      setPostalCode(get(clientInfo, 'cliente.domicilio.codigoPostal', ''));
      setCity(get(clientInfo, 'cliente.domicilio.ciudad', ''));
      setState(get(clientInfo, 'cliente.domicilio.estado', ''));
      setSuburb(get(clientInfo, 'cliente.domicilio.colonia', ''));
      setStreet(get(clientInfo, 'cliente.domicilio.calle', ''));
      setNumber(get(clientInfo, 'cliente.domicilio.numeroExterior', ''));

      // TODO: Refactor?
      // NOTE: Para mostrar el domicilio actual del cliente cuando la plazaRequiereComprobanteDom
      if (!addressFromProof) {
        setNewPostalCode(get(clientInfo, 'cliente.domicilio.codigoPostal', ''));
        setNewCity(get(clientInfo, 'cliente.domicilio.ciudad', ''));
        setNewState(get(clientInfo, 'cliente.domicilio.estado', ''));
        setNewSuburb(get(clientInfo, 'cliente.domicilio.colonia', ''));
        setNewStreet(get(clientInfo, 'cliente.domicilio.calle', ''));
        setNewNumber(get(clientInfo, 'cliente.domicilio.numeroExterior', ''));
      }
    }
  }, [
    setPostalCode,
    setCity,
    setState,
    setSuburb,
    setStreet,
    setNumber,
    editAddress,
    activeStep,
    addressFromProof,
  ]);

  const searchFilterFunction = () => {
    const newData = filter(banksOptionsRef.current, item =>
      includes(toLower(item.id), toLower(bank)),
    );
    const data = get(newData[0], 'nombre');
    setMyBankName(data);
  };

  useEffect(() => {
    searchFilterFunction();
  }, [searchFilterFunction]);

  useEffect(() => {
    if (fileUploaded) {
      handleValidateSelfie();
    }
  }, [fileUploaded]);

  useEffect(() => {
    if (selfie) {
      handleValidateSelfie();
    }
  }, [selfie]);

  const handleOpenCancelVaocuher = () => {
    setCancelVaucher(true);
  };

  const handleCloseCancelVaucher = () => {
    setCancelVaucher(false);
  };

  const handleCancelVaucher = async () => {
    try {
      setLoading(true);
      const body = {
        token,
      };
      posthog.capture('canje_vale/cancelar_vale', {
        token,
      });
      await Axios.post(`${config.api.url}/vales/cancelar-vale`, body);

      setCancelVaucher(false);
      setConfirmCancelVaucher(true);
    } finally {
      setLoading(false);
    }
  };

  const start = () => {
    posthog.capture('canjear_vale/comenzar_canje');
    navigator.geolocation.getCurrentPosition(success, xerror, xoptions);
    setStartExchange(true);
  };

  const fetchDataAddress = async () => {
    try {
      setLoading(true);
      const response = await Axios.get(`${config.api.url}/colonias`, {
        params: {
          filter: {
            where: {
              codigoPostal: newPostalCode,
            },
          },
        },
      });
      const items = response?.data || [];
      const [firstItem] = items;
      if (!firstItem) return;
      const { nomMunicipio, nomEstado, nomColonia } = firstItem;
      setNewCity(nomMunicipio);
      setNewState(nomEstado);
      setNewSuburb(nomColonia);
      setSuburbsOptions(items);
    } finally {
      setLoading(false);
    }
  };

  /**
   * @param {Boolean} alertas
   * @param {Boolean} pagareFisico
   * @param {Boolean} consentimiento
   * @param {Boolean} pagareDigital
   */
  const getMensaje = (alertas, pagareFisico, consentimiento, pagareDigital) => {
    const ALERTAS = 1;
    const PAGARE_FISICO = 2;
    const CONSENTIMIENTO = 4;
    const PAGARE_DIGITAL = 8;
    const clienteNombreCompleto = get(clientInfo, 'cliente.nombreCompleto', '');

    const messages = {
      0: `¡Gracias, ${clienteNombreCompleto} Estás a solo un paso de terminar el canje de tu vale, ahora tu información será validada y te notificaremos cuando se inicie el proceso de depósito en tu tarjeta. ¡Gracias por tu preferencia!`,
      1: `¡Gracias, ${clienteNombreCompleto} Estás a solo un paso de terminar el canje de tu vale, ahora tu vale será revisado y te notificaremos cuando se inicie el proceso de depósito en tu tarjeta. ¡Gracias por tu preferencia!`,
      2: `Gracias por iniciar tu proceso de canje de vale, para finalizar, acude con tu distribuidora para realizar la firma del pagaré. Una vez firmado y cargado el documento se realizará el depósito. ¡Gracias por tu preferencia!`,
      3: `Estás a solo un paso de terminar el canje de tu vale, ahora necesitas acudir con tu distribuidora a firmar el documento pagaré; en cuanto concluyas la firma del documento, tu vale será revisado y te notificaremos cuando quede confirmado. ¡Gracias por tu preferencia!`,
      4: `¡Gracias, ${clienteNombreCompleto} Estás a solo un paso de terminar el canje de tu vale, ahora necesitas firmar el documento que recibirás por WhatsApp en el chat con nombre “Weetrust” que corresponde a tu consentimiento de seguro; en cuanto concluyas la firma del documento se realizará el proceso de depósito en tu tarjeta. ¡Gracias por tu preferencia!`,
      5: `¡Gracias, ${clienteNombreCompleto} Estás a solo un paso de terminar el canje de tu vale, ahora necesitas firmar el documento que recibirás por WhatsApp en el chat con nombre “Weetrust” que corresponde a tu consentimiento de seguro; en cuanto concluyas la firma del documento, tu vale será revisado y te notificaremos cuando se inicie el proceso de depósito en tu tarjeta. ¡Gracias por tu preferencia!`,
      6: `Estás a solo un paso de terminar el canje de tu vale, ahora necesitas firmar el documento que recibirás por WhatsApp en el chat con el nombre “Weetrust” que corresponde a tu consentimiento de seguro. Posteriormente acude con tu distribuidora a firmar el documento pagaré y listo; en cuanto concluyas la firma de los dos documentos se realizará el proceso de depósito en tu tarjeta. ¡Gracias por tu preferencia!`,
      7: `Estás a solo un paso de terminar el canje de tu vale, ahora necesitas firmar el documento que recibirás por WhatsApp en el chat con el nombre “Weetrust” que corresponde a tu consentimiento de seguro. Despues acude con tu distribuidora a firmar el documento pagaré; en cuanto concluyas la firma de los dos documentos, tu vale será revisado y te notificaremos cuando se inicie el proceso de depósito. ¡Gracias por tu preferencia!`,
      8: `¡Gracias, ${clienteNombreCompleto} Estás a solo un paso de terminar el canje de tu vale, ahora necesitas firmar el documento que recibirás por WhatsApp en el chat con nombre “Weetrust” que corresponde a tu pagaré; en cuanto concluyas la firma del documento se realizará el proceso de depósito en tu tarjeta. ¡Gracias por tu preferencia!`,
      9: `¡Gracias, ${clienteNombreCompleto} Estás a solo un paso de terminar el canje de tu vale, ahora necesitas firmar el documento que recibirás por WhatsApp en el chat con nombre “Weetrust” que corresponde a tu pagaré; en cuanto concluyas la firma del documento, tu vale será revisado y te notificaremos cuando se inicie el proceso de depósito en tu tarjeta. ¡Gracias por tu preferencia!`,
      12: `¡Gracias, ${clienteNombreCompleto} Estás a solo un paso de terminar el canje de tu vale, ahora necesitas firmar los documentos que recibirás por WhatsApp en el chat con nombre “Weetrust” que corresponde a tu consentimiento de seguro y pagaré; en cuanto concluyas la firma de los dos documentos se realizará el proceso de depósito en tu tarjeta. ¡Gracias por tu preferencia!`,
      13: `¡Gracias, ${clienteNombreCompleto} Estás a solo un paso de terminar el canje de tu vale, ahora necesitas firmar los documentos que recibirás por WhatsApp en el chat con nombre “Weetrust” que corresponde a tu consentimiento de seguro y pagaré; en cuanto concluyas la firma de los dos documentos, tu vale será revisado y te notificaremos cuando se inicie el proceso de depósito en tu tarjeta. ¡Gracias por tu preferencia!`,
    };

    const estadoActual =
      (alertas ? ALERTAS : 0) +
      (pagareFisico ? PAGARE_FISICO : 0) +
      (consentimiento ? CONSENTIMIENTO : 0) +
      (pagareDigital ? PAGARE_DIGITAL : 0);

    return (
      messages[estadoActual] ||
      'El vale está en proceso de canje, en breve recibirás más información. ¡Gracias por tu preferencia!'
    );
  };

  const handleCanjeVale = async () => {
    try {
      setLoadingFull(true);
      setButtonDisabled(true);
      posthog.capture('canjear_vale/7/enviar_selfie');

      const formData = new FormData();

      if (showIdentityValidator) {
        const selfieBuffer = Buffer.from(selfie, 'base64');
        const selfieFile = new File([selfieBuffer.buffer], 'selfie.png', {
          type: 'image/png',
        });
        formData.set('id', selfieFile);
      }
      formData.set('token', token);
      formData.set('type', 'SPEI');

      if (editCard) {
        formData.set('tarjeta', card.replaceAll(' ', ''));
        formData.set('bancoId', newBank);
      }

      if (!editCard) {
        formData.set('tarjeta', lastDigits.replaceAll(' ', ''));
        formData.set('bancoId', bank);
      }

      console.log({ editAddress, addressFromProof });
      if (editAddress || addressFromProof) {
        formData.set('calle', newStreet);
        formData.set('ciudad', newCity);
        formData.set('estado', newState);
        formData.set('colonia', newSuburb);
        formData.set('codigoPostal', newPostalCode);
        formData.set('numeroExterior', newNumber);
      } else if (!editAddress) {
        formData.set('calle', street);
        formData.set('ciudad', city);
        formData.set('estado', state);
        formData.set('colonia', suburb);
        formData.set('codigoPostal', postalCode);
        formData.set('numeroExterior', number);
      }

      if (videoIdentity) {
        const videoFile = new File([videoIdentity], 'validacion-video.mp4', {
          type: 'video/mp4',
        });
        formData.set('video', videoFile);
      }

      if (coasegurados && validCoasegurados) {
        formData.set('coasegurados', JSON.stringify(coasegurados));
        formData.set('editCoasegurados', editCoasegurados ? 1 : 0);
      }

      if (beneficiarios && validBeneficiarios) {
        formData.set('beneficiarios', JSON.stringify(beneficiarios));
        formData.set('editBeneficiarios', editBeneficiarios ? 1 : 0);
      }

      if (seguroSelected) {
        formData.set('seguroId', seguroSelected);
      }

      // formData.set('latitud', latitud);
      // formData.set('longitud', longitud);
      formData.set('latitud', latitudRef.current);
      formData.set('longitud', longitudRef.current);

      if (documentoClienteId.current) {
        formData.set('documentoClienteId', documentoClienteId.current);
      } else {
        formData.set('documentoClienteId', null);
      }

      const response = await Axios.patch(
        `${config.api.url}/vales/canjearVale`,
        formData,
        {
          'Content-Type': 'multipart/form-data',
        },
      );

      const isError = get(response, 'data.output.payload.error', false);
      const isSuccess =
        get(response, 'data.success', false) || get(response, 'data', false);

      const hasToSignConsentimiento = get(
        response,
        'data.hasToSignConsentimiento',
        false,
      );

      const hasToSignPagareDigital = get(
        response,
        'data.hasToSignPagareDigital',
        false,
      );

      const pagarePendiente = get(response, 'data.pagarePendiente', false);
      const revisionPendienteDomicilio = get(
        response,
        'data.revisionPendienteDomicilio',
        false,
      );
      if (isError || !isSuccess) {
        setErrorText(
          get(
            response,
            'data.output.payload.message',
            'No se pudo validar la identidad del cliente.',
          ),
        );
        setButtonDisabled(false);
        return;
      }

      setSuccessText('Vale canjeado con éxito.');
      posthog.capture('canjear_vale/8/canjeado_exito', {
        response,
        payload: formData,
      });

      setValeCanjeado(
        getMensaje(
          revisionPendienteDomicilio,
          pagarePendiente,
          hasToSignConsentimiento,
          hasToSignPagareDigital,
        ),
      );

      setVaucherRedeemed(true);
    } catch (error) {
      setErrorText('Error canjeando vale');
      console.log(error);
      setButtonDisabled(false);
    } finally {
      setLoadingFull(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchConfig();
    LogRocket.init('e5qmbp/conmigo-canje-digital');
  }, []);

  const uploadInes = async () => {
    try {
      setLoadingFull(true);

      const formData = new FormData();
      // TODO ARRAYBUFFER, READ FROM BASE64
      // NOTE: Original
      // const ineFrenteBuffer = Buffer.from(ineFrente, 'base64');
      // const ineFrenteFile = new File(
      //   [ineFrenteBuffer.buffer],
      //   'frenteIne.png',
      //   {
      //     type: 'image/png',
      //   },
      // );

      const ineFrenteFile = await compressImage(ineFrente, 'frenteIne');

      const clienteId = get(clientInfo, 'clienteId', '');
      formData.append('files', ineFrenteFile);
      formData.append('id', clienteId);
      formData.append('tipo', 'Frente');
      await Axios.patch(
        `${config.api.url}/clientes/subirIdentificacion`,
        formData,
      );

      const formData2 = new FormData();
      // NOTE: Original
      // const ineReversoBuffer = Buffer.from(ineReverso, 'base64');
      // const ineReversoFile = new File(
      //   [ineReversoBuffer.buffer],
      //   'reversoIne.png',
      //   {
      //     type: 'image/png',
      //   },
      // );
      // const ineAtras = new File([ineReversoFile], 'backIne.png', {
      //   type: 'image/png',
      // });
      const ineAtras = await compressImage(ineReverso, 'backIne');
      formData2.append('files', ineAtras);
      formData2.append('id', clienteId);
      formData2.append('tipo', 'Atras');
      await Axios.patch(
        `${config.api.url}/clientes/subirIdentificacion`,
        formData2,
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFull(false);
    }
  };

  const handleNext = async () => {
    let step = 1;
    if (activeStep === 4 && requierePagareDigital.current) {
      step += 1;
    }

    if (activeStep === 3 && (editCoasegurados || editBeneficiarios)) {
      console.log(
        'Se subira el comprobante de domicilio en caso de que sea necesario',
      );
    }

    if (activeStep === 5 && cambiaFirma) {
      console.log('Subir firma');
      await guardarFirma();
    }

    if (activeStep === 6 && (ineFrente || ineReverso)) {
      await uploadInes();
    }

    if (activeStep === 6) {
      if (
        editAddress ||
        editCard ||
        editBeneficiarios ||
        editCoasegurados ||
        !isEmpty(ineFrente) ||
        !isEmpty(ineReverso) ||
        addressFromProof ||
        !documentoClienteValidado.current
      ) {
        setShowIndentityValidator(true);
      }
    }
    if (!capturados.includes(activeStep)) {
      switch (activeStep) {
        case 0:
          if (capturados.includes(activeStep)) break;
          posthog.capture('canjear_vale/0/capturar_tarjeta');
          break;
        case 1:
          posthog.capture('canjear_vale/1/elegir_seguro');
          break;
        case 2:
          posthog.capture('canjear_vale/2/capturar_coasegurados');
          break;
        case 3:
          posthog.capture('canjear_vale/3/capturar_beneficiarios');
          break;
        case 4:
          posthog.capture('canjear_vaje/4/capturar_domicilio');
          break;
        case 5:
          posthog.capture('canjear_vaje/5/subir_firma');
          break;
        case 6:
          posthog.capture('canjear_vale/6/fotos_id');
          break;
        default:
      }
      setCapturados(prev => [...prev, activeStep]);
    }

    setActiveStep(prevActiveStep => prevActiveStep + step);
  };

  const handleBack = () => {
    let step = 1;
    if (activeStep === 7) {
      setTermsAgreed(false);
      setErrorSelfie(null);
      setFileUploaded(null);
      setErrorText(null);
    }
    if (activeStep === 2) {
      if (coaseguradosCopy.length !== 0) {
        setCoasegurados(coaseguradosCopy);
      }
      setEditCoasegurados(false);
    }
    if (activeStep === 3) {
      if (beneficiariosCopy.length !== 0) {
        setBeneficiarios(beneficiariosCopy);
      }
      setEditBeneficiarios(false);
    }

    if (activeStep === 6 && requierePagareDigital.current) {
      step += 1;
    }

    setActiveStep(prevActiveStep => prevActiveStep - step);
  };

  const handleTermsAgreedOpen = () => {
    setTermsAgreedOpen(true);
  };

  const handleTermsAgreedClose = () => {
    setTermsAgreedOpen(false);
  };

  const errorConfirmCard = confirmCardTouched && confirmCard !== card;

  const handleValidateSelfie = async () => {
    try {
      setLoadingFull(true);

      const formData = new FormData();

      const valeId = get(clientInfo, 'id', '');

      // const selfieBuffer = Buffer.from(selfie, 'base64');
      // const selfieFile = new File([selfieBuffer.buffer], 'selfie.png', {
      //   type: 'image/png',
      // });
      const selfieFile = await compressImage(selfie, 'selfie');

      formData.set('valeId', valeId);
      formData.set('selfie', selfieFile);

      const response = await Axios.patch(
        `${config.api.url}/vales/validarCliente`,
        formData,
        {
          'Content-Type': 'multipart/form-data',
        },
      );

      const isError = get(response, 'data.output.payload.error', false);
      const isSuccess = get(response, 'data.success', false);
      if (isError || !isSuccess) {
        setErrorText(
          get(
            response,
            'data.output.payload.message',
            'No se pudo validar la identidad del cliente.',
          ),
        );
        setButtonDisabled(false);
        setErrorSelfie(
          get(
            response,
            'data.output.payload.message',
            'No se puedo validar la identidad del cliente.',
          ),
        );
        setShowIndentityValidator(true);
        setErrorFaceCapture(true);
      } else {
        setErrorText('');
        setButtonDisabled(false);
        setErrorSelfie(null);
        setErrorFaceCapture(false);
        setSuccessText('Identidad validada con éxito!');
        setSuccessSelfie('Identidad validada con éxito!');
      }
    } catch (error) {
      setErrorText('Error validando identidad');
      setErrorSelfie('Error validando la identidad');
      setValidationAttempt(validationAttempt + 1);
    } finally {
      setLoadingFull(false);
    }
  };

  const editCardStatus = e => {
    setEditCard(e);
    if (editCard) {
      setCardTouched(false);
      setInputsDisabled(false);
      setShowIndentityValidator(true);
      if (transferenciaStpRejected.current) {
        setActualizarTarjeta(true);
        setConfirmCard('');
        setCard('');
        setBank('');
      }
      setNewBank('');
    }
  };

  const editAddressStatus = editar => {
    setEditAddress(editar);
    if (editar) {
      setShowIndentityValidator(true);
    } else {
      setShowIndentityValidator(false);
    }
  };

  const editarCoasegurados = editar => {
    setEditCoasegurados(editar);
    if (editar) {
      setShowIndentityValidator(true);
    } else {
      setShowIndentityValidator(false);
    }
  };

  const editarBeneficiarios = editar => {
    setEditBeneficiarios(editar);
    if (editar) {
      setShowIndentityValidator(true);
    } else {
      setShowIndentityValidator(false);
    }
  };

  const getPagareWithVariables = () => {
    if (!pagareTemplate || !clientInfo) return '';
    let html = pagareTemplate;
    // TODO: Se tiene que agregar a un useState o useRef?))
    const infoPagareCliente = get(clientInfo, 'infoPagareCliente', {});

    html = html.replaceAll(
      '#{nombreCliente}',
      `<b>${infoPagareCliente.nombreCliente}</b>`,
    );
    html = html.replaceAll(
      '#{montoVale}',
      `<b>${Numeral(infoPagareCliente?.montoVale || 0).format('$0,0.00')}</b>`,
    );

    html = html.replaceAll(
      '#{montoValeLetra}',
      `<b>${infoPagareCliente.montoValeLetra}</b>`,
    );

    if (addressFromProof || editAddress) {
      html = html.replaceAll('#{ciudadDt}', `<b>${newCity}</b>`);

      html = html.replaceAll('#{estadoDt}', `<b>${newState}</b>`);
    } else {
      html = html.replaceAll(
        '#{ciudadDt}',
        `<b>${infoPagareCliente.ciudadDt}</b>`,
      );

      html = html.replaceAll(
        '#{estadoDt}',
        `<b>${infoPagareCliente.estadoDt}</b>`,
      );
    }

    if (
      !editAddress &&
      !addressFromProof &&
      !infoPagareCliente.domicilioTemporal
    ) {
      html = html.replaceAll(
        '#{domicilioCliente}',
        `<b>${infoPagareCliente.domicilioCliente}</b>`,
      );
    } else {
      let domicilioClienteFormatted = '';
      if (infoPagareCliente.domicilioTemporal && !addressFromProof) {
        domicilioClienteFormatted = `${street} #${number}, ${suburb} ${postalCode} ${city} ${state}`;
      } else {
        domicilioClienteFormatted = `${newStreet} #${newNumber}, ${newSuburb} ${newPostalCode} ${newCity} ${newState}`;
      }

      html = html.replaceAll(
        '#{domicilioCliente}',
        `<b>${domicilioClienteFormatted}</b>`,
      );
    }

    if (
      !editAddress &&
      !addressFromProof &&
      !infoPagareCliente.domicilioTemporal
    ) {
      html = html.replaceAll(
        '#{lugarFecha}',
        `<b>${infoPagareCliente.lugarFecha}</b>`,
      );
    } else {
      let newLugarFecha = ``;
      if (infoPagareCliente.domicilioTemporal && !addressFromProof) {
        newLugarFecha = `${city}, ${state} a ${moment().format('DD/MM/YYYY')}`;
      } else {
        newLugarFecha = `${newCity}, ${newState} a ${moment().format(
          'DD/MM/YYYY',
        )}`;
      }

      html = html.replaceAll('#{lugarFecha}', `<b>${newLugarFecha}</b>`);
    }

    html = html.replaceAll(
      '#{folioVale}',
      `<b>${infoPagareCliente.folioVale}</b>`,
    );

    html = html.replaceAll(
      '#{firmaDigital}',
      `_________________ <br><b>Firma de Aceptado</b>`,
    );
    return parse(html);
  };

  const fetchConfig = async () => {
    try {
      const response = await Axios.get(`${config.api.url}/configuraciones`);
      setTermsAndConditions(get(response, 'data[0].terminosCondiciones', ''));
      setIdentityValidationAttempts(
        get(response, 'data[0].intentosValidacionIdentidad', ''),
      );
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    try {
      const [
        banksRes,
        parentescosRes,
        segurosRes,
        tokenRes,
      ] = await Promise.all([
        Axios.get(`${config.api.url}/bancos`, {
          params: {
            filter: {
              where: {
                estatus: 'activo',
                nombre: { nin: ['STP', 'TARJETA DE CORAZÓN'] },
              },
            },
          },
        }),
        Axios.get(`${config.api.url}/parentescos`, {
          params: {
            filter: {
              where: {
                estatus: 'activo',
              },
            },
          },
        }),
        Axios.get(`${config.api.url}/seguros`, {
          params: {
            filter: {
              where: {
                estatus: 'activo',
              },
            },
          },
        }),
        Axios.get(`${config.api.url}/vales/busqueda-token`, {
          params: {
            token,
          },
        }),
      ]);

      const banks = get(banksRes, 'data', []) || [];
      // setBanksOptions(banks);
      banksOptionsRef.current = banks;

      const parentescos = get(parentescosRes, 'data', []) || [];
      setParentescoOptions(parentescos);

      const seguro = get(segurosRes, 'data', []) || [];
      setSeguroOptions(seguro);

      let response = tokenRes;
      setPagareTemplate(response.data.pagareTemplate);
      setTokenNubarium(response.data.tokenNubarium);
      setActualizarTarjeta(response.data.actualizarTarjeta);
      transferenciaStpRejected.current = response.data.actualizarTarjeta;
      tarjetaRejected.current = response.data.tarjetaRejected;
      bancoIdRejected.current = response.data.bancoIdRejected;

      if (!get(response, 'data')) {
        setNotFound(true);
      }

      // NOTE: Asigna la fimra del cliente al flujo del canje
      // const firmaDigital = get(response, 'data.cliente.firmaDigital', '');
      // if (!isEmpty(firmaDigital)) {
      //   setSignature(firmaDigital);
      // }

      requierePagareDigital.current = get(
        response,
        'data.requierePagareDigital',
        '',
      );

      requiereComprobanteDom.current = get(
        response,
        'data.requiereComprobanteDom',
        '',
      );

      plazaRequiereComprobanteDom.current = get(
        response,
        'data.plazaRequiereComprobanteDom',
        '',
      );

      documentoClienteValidado.current = get(
        response,
        'data.documentoCliente.validadoCliente',
        false,
      );

      documentoClienteId.current = get(
        response,
        'data.documentoCliente.documentoClienteId',
        null,
      );

      numeroIntentosValidacionComprobanteDomicilio.current = get(
        response,
        'data.numeroIntentosValidacionComprobanteDomicilio',
        '',
      );

      const voucherStatus = get(response, 'data.estatus', '');
      if (voucherStatus !== 'porcobrar') {
        if (voucherStatus === 'cancelado' || voucherStatus === 'bloqueado') {
          setAlreadyUsed(
            'Este vale se encuentra cancelado, verifique con su distribuidora.',
          );
        } else if (voucherStatus === 'activo' || voucherStatus === 'cobrado') {
          setAlreadyUsed(
            'Este vale ya fue canjeado. Verifique con su distribuidora.',
          );
        } else {
          setAlreadyUsed(
            'No se encuentra información del vale. Verifique con su distribuidora.',
          );
        }
        return;
      }

      const disposicion = get(response, 'data.disposicionVale', false);
      if (!disposicion) {
        setAlreadyUsed(
          'No es posible canjear el vale. Distribuidora sin saldo disponible.',
        );
      }

      const digits = get(response, 'data.cliente.tarjeta', '');
      if (digits) {
        setLastDigits(digits);
        setCardTouched(true);
      } else {
        setInputsDisabled(false);
      }

      const bankId = get(response, 'data.cliente.bancoId', '');
      if (bankId) {
        setBank(bankId);
        setNewBank(bankId);
      }

      const clienteInfo = get(response, 'data', {});
      setClientInfo(clienteInfo);

      posthog.identify(clienteInfo.cliente.curp, {
        ...clienteInfo.cliente,
        nombreCompleto: clienteInfo.cliente.nombreCompleto,
      });

      LogRocket.identify(clienteInfo.cliente.id, {
        name: clienteInfo.cliente.nombreCompleto,
        celular: clienteInfo.cliente.celular,
        vale: clienteInfo.folio,
      });

      setValidationAttempt(get(response, 'data.intentoValidacionIdentidad'));
      const savedAddress = get(response, 'data.cliente.domicilio', {});
      if (!savedAddress && plazaRequiereComprobanteDom.current === false) {
        setEditAddress(true);
      }
      setExistAddress(savedAddress);
      setExistCard(get(response, 'data.cliente.tarjeta', {}) || null);
      if (isEmpty(get(response, 'data.cliente.tarjeta', {}))) {
        editCardStatus(true);
      }

      setShowIndentityValidator(
        !get(response, 'data.cliente.validacionFacial', true),
      );

      // NOTE: Might Delete
      const identificacionCliente = get(
        response,
        'data.cliente.identificacionCliente',
        [],
      );
      if (!isEmpty(identificacionCliente)) {
        setIneFrontUrl(find(identificacionCliente, { tipo: 'Frente' }).url);
        setIneBackUrl(find(identificacionCliente, { tipo: 'Atras' }).url);
      }

      const clienteId = get(response, 'data.clienteId', '');
      response = await Axios.get(`${config.api.url}/coasegurados`, {
        params: {
          filter: {
            where: {
              clienteId,
              estatus: 'activo',
            },
          },
        },
      });
      const coasegurades = get(response, 'data', []) || [];
      if (coasegurades.length !== 0) {
        setValidCoasegurados(true);
        setCoasegurados(coasegurades);
        setCoaseguradosCopy(coasegurades);
      }

      response = await Axios.get(`${config.api.url}/beneficiarios`, {
        params: {
          filter: {
            where: {
              clienteId,
              estatus: 'activo',
            },
          },
        },
      });
      const beneficiaries = get(response, 'data', []) || [];
      if (beneficiaries.length !== 0) {
        setValidBeneficiarios(true);
        setBeneficiarios(beneficiaries);
        setBeneficiariosCopy(beneficiaries);
      } else {
        setEditBeneficiarios(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setLoadingFull(false);
    }
  };

  useEffect(() => {
    if (!isEmpty(parentescoOptions)) {
      setParentescosCoaseguradosOpt(
        filter(parentescoOptions, { esCoasegurado: true }),
      );
    }
  }, [parentescoOptions]);

  useEffect(() => {
    if (seguroOptions.length === 1) {
      setSeguroSelected(head(seguroOptions).id);
    }
  }, [seguroOptions]);

  const handleValidateCoasegurados = isValid => {
    setValidCoasegurados(isValid);
  };

  const handleValidateBeneficiarios = isValid => {
    setValidBeneficiarios(isValid);
  };

  const handleCancelEditCoasegurados = () => {
    setEditCoasegurados(false);
    setCoasegurados(coaseguradosCopy);
    setShowIndentityValidator(false);
  };

  const handleCancelEditBeneficiarios = () => {
    setEditBeneficiarios(false);
    setBeneficiarios(beneficiariosCopy);
  };

  const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i += 1) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const disabled =
    buttonDisabled ||
    !termsAgreed ||
    !seguroSelected ||
    (showIdentityValidator && !selfie) ||
    (!inputsDisabled && card !== confirmCard) ||
    errorSelfie;

  const errorCard = cardTouched && !isCreditCard(card);

  const rejectedCard = tarjetaRejected.current;
  const normalizedConfirmCard = confirmCard.replaceAll(' ', '');
  const normalizedCard = card.replaceAll(' ', '');

  const hasRejectedCardCombination =
    (rejectedCard === normalizedConfirmCard ||
      rejectedCard === normalizedCard) &&
    bancoIdRejected.current === String(newBank) &&
    transferenciaStpRejected.current;

  const isCardStepInvalid =
    (editCard && isEmpty(card)) ||
    (editCard && isEmpty(confirmCard)) ||
    (editCard && activeStep === 0 && confirmCard !== card && errorCard) ||
    (editCard && !newBank) ||
    (editCard && activeStep === 0 && cardTouched && !isCreditCard(card)) ||
    (editCard &&
      activeStep === 0 &&
      confirmCardTouched &&
      confirmCard !== card);

  const isInsuranceStepInvalid = activeStep === 1 && !seguroSelected;

  const isCoaseguradosStepInvalid =
    editCoasegurados && activeStep === 2 && !validCoasegurados;

  const isBeneficiariosStepInvalid =
    editBeneficiarios && activeStep === 3 && !validBeneficiarios;

  const isAddressStepInvalid =
    editAddress &&
    activeStep === 4 &&
    (isEmpty(newPostalCode) ||
      isEmpty(newCity) ||
      isEmpty(newState) ||
      isEmpty(newSuburb) ||
      isEmpty(newStreet) ||
      isEmpty(newNumber));

  const isComprobanteEmpty =
    activeStep === 4 &&
    (isEmpty(addressProofFile) || isEmpty(addressProofFileName)) &&
    !editAddress &&
    requiereComprobanteDom.current;

  const isSignatureStepInvalid = activeStep === 5 && !signature;

  const isIdentificationStepInvalid =
    activeStep === 6 &&
    isEmpty(ineFrente) &&
    isEmpty(ineReverso) &&
    isEmpty(ineFrontUrl) &&
    isEmpty(ineBackUrl);

  const isNextDisabled =
    (isEmpty(bank) && !newBank) ||
    actualizarTarjeta ||
    hasRejectedCardCombination ||
    activeStep === 7 ||
    isAddressStepInvalid ||
    isCardStepInvalid ||
    isInsuranceStepInvalid ||
    isCoaseguradosStepInvalid ||
    isBeneficiariosStepInvalid ||
    isSignatureStepInvalid ||
    isIdentificationStepInvalid ||
    isComprobanteEmpty;

  const prepareForNubariumSDK = () => {
    setCurrentlyIdCapture(true);
    setAlreadyIdCapture(!alreadyIdCapture);
    setIneFrente('');
    setIneReverso('');
    setIneFrontUrl('');
    setIneBackUrl('');
  };

  // NOTE: DEBUG
  // console.log({ ineFrente });
  // console.log({ ineReverso });
  // console.log({ selfie });
  // console.log({ showIdentityValidator });
  // console.log({ buttonDisabled });
  // console.log({ disabled });
  // console.log('(showIdentityValidator && !selfie)');
  // console.log(showIdentityValidator && !selfie);
  const xoptions = {
    enableHighAccuracy: true,
    timeout: 120000,
    maximumAge: 0,
  };

  function success(pos) {
    const crd = pos.coords;

    // console.log('Your current position is:');
    // console.log(`Latitude : ${latitud}`);
    // console.log(`Longitude: ${longitud}`);
    // console.log(`Latitude : ${latitudRef.current}`);
    // console.log(`Longitude: ${longitudRef.current}`);
    // console.log(`More or less ${crd.accuracy} meters.`);
    // setLatitud(crd.latitude);
    // setLongitud(crd.longitude);

    latitudRef.current = crd.latitude;
    longitudRef.current = crd.longitude;
  }

  function xerror(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
    setUserBlockGeolocation(true);
  }

  // navigator.geolocation.getCurrentPosition(success, xerror, xoptions);

  // useEffect(() => {
  //   console.log('render again');
  // }, [userBlockGeolocation]);

  return (
    <ContainerGeneral>
      <NavBarContainer>
        <Link to="/">
          <img className="logo" src="/images/logo.png" alt="ConmigoVales" />
        </Link>
      </NavBarContainer>
      {startExchange === false && (
        <>
          {loading && <Loader />}
          {!notFound && Boolean(alreadyUsed) && (
            <>
              <Content>
                <h1>¡Gracias por tu preferencia!</h1>
                <div style={{ textAlign: 'center' }}>{alreadyUsed}</div>
              </Content>
            </>
          )}
          {notFound && (
            <Content>
              <div>
                Este vale no existe o el link es incorrecto. Contacte a su
                distribuidor.
              </div>
            </Content>
          )}
          {!loading && !alreadyUsed && !notFound && (
            <>
              <Content>
                <h1>Canje Digital</h1>
                {confirmCancelVaucher === false && (
                  <>
                    <ContainerData>
                      <h3>Folio: </h3>
                      <div className="numbertwo">{`${clientInfo?.folio ||
                        ''}`}</div>
                    </ContainerData>
                    <ContainerData>
                      <h3>{clientInfo.distribuidora.folio} </h3>
                      <div className="numbertwo">
                        {clientInfo?.distribuidora.prospecto.usuario
                          .nombreCompleto || ''}
                      </div>
                    </ContainerData>
                    <div className="firstLabel">{`¡Hola, ${get(
                      clientInfo,
                      'cliente.nombreCompleto',
                      '',
                    )}!`}</div>
                    <ContainerData>
                      <h3>Iniciarás tu canje de vale por</h3>
                      <div className="number">
                        {Numeral(clientInfo?.monto || 0).format('$ 0,0.00')}
                      </div>
                      <h3>&nbsp;pesos</h3>
                    </ContainerData>
                    <ContainerData>
                      <h3>{`a ${clientInfo?.cantidadPagos ||
                        ''} quincenas de `}</h3>
                      <div className="numbertwo">{`${Numeral(
                        clientInfo?.pagoQuincenal || 0,
                      ).format('$ 0,0.00')} pesos`}</div>
                    </ContainerData>

                    <ContentButonGroup>
                      <ContentButon>
                        <Button
                          fullWidth
                          variant="contained"
                          color="primary"
                          size="large"
                          onClick={start}
                        >
                          Comenzar canje
                        </Button>
                      </ContentButon>
                      <ContentButon>
                        <Button
                          fullWidth
                          variant="outlined"
                          color="primary"
                          size="large"
                          onClick={handleOpenCancelVaocuher}
                        >
                          No quiero el vale
                        </Button>
                      </ContentButon>
                    </ContentButonGroup>
                  </>
                )}

                {confirmCancelVaucher === true && (
                  <>
                    <div className="greeting">Vale cancelado</div>
                    <h2>{`El vale con el folio: ${get(
                      clientInfo,
                      'folio',
                      '',
                    )} ha sido cancelado exitosamente.`}</h2>
                  </>
                )}

                <Dialog
                  open={cancelVaucher}
                  onClose={handleCloseCancelVaucher}
                  maxWidth="sm"
                >
                  <IconButton
                    style={{
                      position: 'absolute',
                      top: 5,
                      right: 5,
                      zIndex: 10,
                    }}
                    onClick={handleCloseCancelVaucher}
                  >
                    <CloseIcon />
                  </IconButton>
                  <ContentDialog>
                    <h1>¿Estás seguro de que no quieres el vale?</h1>
                    <h2>Al rechazarlo se cancelará y no podrás canjearlo</h2>
                    <ButtonGrupDialog>
                      <Button
                        color="primary"
                        onClick={handleCloseCancelVaucher}
                        style={{ textTransform: 'none', marginRight: 15 }}
                      >
                        Cancelar
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleCancelVaucher}
                        style={{ textTransform: 'none' }}
                      >
                        Aceptar
                      </Button>
                    </ButtonGrupDialog>
                  </ContentDialog>
                </Dialog>
              </Content>
            </>
          )}
        </>
      )}

      {startExchange && (
        <>
          {activeStep === 0 && editCard === false && existCard !== null ? (
            <>
              <Content>
                <h1>Tarjeta de debito</h1>

                {loading && <div>Cargando...</div>}
                {!notFound && Boolean(alreadyUsed) && (
                  <>
                    <div>{alreadyUsed}</div>
                  </>
                )}
                {notFound && (
                  <div>
                    Este vale no existe o el link es incorrecto. Contacte a su
                    distribuidor
                  </div>
                )}

                {Boolean(valeCanjeado) && (
                  <div className="greeting">{valeCanjeado}</div>
                )}
                <div className="greeting">Aquí estarías recibiendo tu vale</div>
                <ContainerCard>
                  <h2>Número de tarjeta</h2>
                  <Button
                    variant="text"
                    color="primary"
                    onClick={() => editCardStatus(true)}
                  >
                    Editar tarjeta
                  </Button>
                </ContainerCard>
                {bank && (
                  <div>
                    <h2
                      style={{ width: '100%' }}
                    >{`**** **** **** ${lastDigits.substring(12)}`}</h2>
                    <h2 style={{ width: '100%' }}>Banco</h2>
                    <h2 style={{ width: '100%' }}>{myBankName}</h2>
                  </div>
                )}
                {typeof bank === 'string' && isEmpty(bank) && (
                  <div>
                    <h1>
                      Es necesario que seleccione un banco para poder continuar
                    </h1>
                  </div>
                )}
                {actualizarTarjeta && (
                  <ContainerCard>
                    <h1>Es necesario que cambies tu tarjeta para continuar.</h1>
                  </ContainerCard>
                )}
              </Content>
            </>
          ) : null}
        </>
      )}

      {(startExchange && activeStep === 0 && editCard) ||
      (startExchange && activeStep === 0 && existCard === null) ? (
        <Content>
          {actualizarTarjeta && (
            <h1>Es necesario que cambies tu tarjeta para continuar</h1>
          )}
          <h1>Tarjeta de debito</h1>
          <div className="greeting">
            Ingresa tu tarjeta de debito para recibir tu préstamo
          </div>
          <ContainerCard>
            <h2>Número de tarjeta</h2>
            {editCard && (
              <Button
                variant="text"
                color="primary"
                onClick={() => editCardStatus(false)}
              >
                Cancelar
              </Button>
            )}
          </ContainerCard>
          <TextField
            id="card"
            className="input"
            error={errorCard}
            helperText={errorCard && 'Ingrese una tarjeta válida'}
            value={card}
            placeholder="Número de tarjeta"
            variant="outlined"
            fullWidth
            onChange={e => setCard(e.target.value)}
            onBlur={() => {
              setCardTouched(true);
              setShowIndentityValidator(true);
            }}
            InputProps={{
              inputComponent: TextMaskCustom,
              inputProps: {
                placeholder: 'Ingresa los 16 dígitos de tu tarjeta',
              },
            }}
            autoFocus
            disabled={inputsDisabled}
          />
          <TextField
            id="card"
            className="input"
            error={errorConfirmCard}
            helperText={errorConfirmCard && 'Las tarjetas no coinciden'}
            value={confirmCard}
            fullWidth
            placeholder="Confirme número de tarjeta"
            variant="outlined"
            onChange={e => {
              if (
                e.target.value.replaceAll(' ', '') ===
                  tarjetaRejected.current &&
                transferenciaStpRejected.current
              ) {
                setActualizarTarjeta(true);
                // console.log('Igual');
                // console.log(lastDigits);
                // console.log(confirmCard.replaceAll(' ', ''));
                // console.log(
                //   actualizarTarjeta &&
                //     lastDigits !== confirmCard &&
                //     lastDigits !== card,
                // );
                // console.log(lastDigits);
                // console.log({ actualizarTarjeta });
              } else if (e.target.value.replaceAll(' ', '').length === 16) {
                // console.log('No Igual');
                // console.log(lastDigits.replace(' ', ''));
                // console.log(confirmCard.replaceAll(' ', ''));
                setActualizarTarjeta(false);
              }
              setConfirmCard(e.target.value);
            }}
            onBlur={() => setConfirmCardTouched(true)}
            InputProps={{
              inputComponent: TextMaskCustom,
              inputProps: {
                placeholder: 'Confirme número de tarjeta',
              },
            }}
            disabled={inputsDisabled}
          />
          <h2 style={{ width: '100%' }}>Banco</h2>
          <FormControl variant="outlined" className="input" fullWidth>
            <Select
              labelId="bank-label"
              id="bank"
              value={newBank}
              onChange={event => {
                if (event.target.value === bancoIdRejected.current) {
                  setActualizarTarjeta(true);
                } else {
                  setActualizarTarjeta(false);
                }
                setNewBank(event.target.value);
              }}
              displayEmpty
              inputProps={{ 'aria-label': 'Banco' }}
              style={{ color: bank ? '#212121' : '#a2a2a2' }}
              disabled={inputsDisabled}
            >
              <MenuItem value="" disabled>
                Banco
              </MenuItem>
              {banksOptionsRef.current.map(c => (
                <MenuItem value={c.id} key={c.id}>
                  {c.nombre}
                </MenuItem>
              ))}
              <FormHelperText>Banco</FormHelperText>
            </Select>
          </FormControl>
        </Content>
      ) : null}

      {activeStep === 1 && (
        <Content>
          <h1>Seguro de Vida</h1>
          <ContainerCard>
            <div className="greeting">
              La cuota del seguro se sumará a tu pago quincenal.
            </div>
          </ContainerCard>
          <FormControl fullWidth>
            <RadioGroup
              aria-label="options"
              name="options"
              value={seguroSelected}
            >
              {seguroOptions.map(option => (
                <Card
                  key={option.id}
                  variant="outlined"
                  style={{
                    marginBottom: '8px',
                    border: `3px solid ${
                      seguroSelected === option.id ? '#994878' : '#00000042'
                    }`,
                    cursor: 'pointer',
                  }}
                  onClick={() => setSeguroSelected(option.id)}
                >
                  <CardContent>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div style={{ fontWeight: 'bold' }}>{option.nombre}</div>
                      <div style={{ color: '#994878' }}>
                        $ {option.montoAPagar.toFixed(2)} quincenal
                      </div>
                    </div>
                    <div style={{ color: '#808080' }}>
                      ${Numeral(option.importeAsegurado || 0).format('0,0')}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      {/* <div> */}
                      {/*   {option.beneficios.map(beneficio => ( */}
                      {/*     <div key={crypto.randomUUID()}>{beneficio}</div> */}
                      {/*   ))} */}
                      {/* </div> */}
                      {option.default && (
                        <div
                          style={{
                            marginLeft: 'auto',
                            backgroundColor: '#994878',
                            color: 'white',
                            fontWeight: 'bold',
                            borderRadius: '4px',
                            padding: '4px',
                            marginBottom: 'auto',
                          }}
                        >
                          ¡Recomendado!
                        </div>
                      )}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </RadioGroup>
          </FormControl>
          {seguroSelected &&
            seguroOptions.at(
              seguroOptions.map(seguro => seguro.id).indexOf(seguroSelected),
            ) && (
              <BeneficiosList>
                {seguroOptions
                  .at(
                    seguroOptions
                      .map(seguro => seguro.id)
                      .indexOf(seguroSelected),
                  )
                  .beneficios.map(beneficio => (
                    <li key={beneficio.nombre}>
                      <strong>{beneficio.nombre}:</strong> {beneficio.beneficio}
                    </li>
                  ))}
              </BeneficiosList>
            )}
        </Content>
      )}

      {activeStep === 2 && (
        <Content>
          <h1>Coasegurado(s) de Seguro de Vida</h1>
          <ContainerCard>
            <div className="greeting">
              Estoy de acuerdo que el uso de medios electrónicos será utilizado
              para otorgar el consentimiento y la designación de coasegurados
            </div>
          </ContainerCard>
          <ContainerCard>
            <div className="greeting">
              Verifica que la información de tus coasegurados sea exactamente
              igual a la registrada en la INE o acta de nacimiento
            </div>
          </ContainerCard>
          {!editCoasegurados && coaseguradosCopy.length !== 0 ? (
            <div style={{ width: '100%' }}>
              <ContainerCard style={{ marginTop: '20px' }}>
                <div className="greeting">Coasegurados</div>
                <Button
                  variant="text"
                  color="primary"
                  onClick={() => editarCoasegurados(true)}
                >
                  Editar coasegurados
                </Button>
              </ContainerCard>
              <div>
                {coasegurados.map(coasegurado => (
                  <div key={coasegurado.id} style={{ marginBottom: '20px' }}>
                    <div>
                      <strong>Nombre:</strong> {coasegurado.nombre}
                    </div>
                    <div>
                      <strong>Parentesco:</strong>{' '}
                      {parentescosCoaseguradosOpt
                        .find(
                          parentesco =>
                            parentesco.id === coasegurado.parentescoId,
                        )
                        .nombre.toLowerCase()}
                    </div>
                    <div>
                      <strong>Fecha de nacimiento:</strong>{' '}
                      {moment(coasegurado.fechaNacimiento)
                        .locale('es')
                        .format('DD MMMM YYYY')}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div style={{ width: '100%', marginBottom: '60px' }}>
              <ContainerCard style={{ marginTop: '20px' }}>
                <div className="greeting">Coasegurados</div>
                {coaseguradosCopy.length !== 0 && (
                  <Button
                    variant="text"
                    color="primary"
                    onClick={() => handleCancelEditCoasegurados()}
                  >
                    Cancelar
                  </Button>
                )}
              </ContainerCard>
              <CoaseguradosForm
                parentescos={parentescosCoaseguradosOpt}
                coasegurados={coasegurados}
                setCoaseguradosArray={setCoasegurados}
                onValidation={handleValidateCoasegurados}
              />
            </div>
          )}
        </Content>
      )}

      {activeStep === 3 && (
        <Content>
          <h1>Beneficiario(s) de Seguro de Vida</h1>
          <ContainerCard>
            <div className="greeting">
              Estoy de acuerdo que el uso de medios electrónicos será utilizado
              para otorgar el consentimiento y la designación de beneficiarios
            </div>
          </ContainerCard>
          <ContainerCard>
            <div className="greeting">
              Verifica que la información de tus beneficiarios sea exactamente
              igual a la registrada en la INE o acta de nacimiento
            </div>
          </ContainerCard>
          {!editBeneficiarios && beneficiariosCopy.length !== 0 ? (
            <div style={{ width: '100%' }}>
              <ContainerCard style={{ marginTop: '20px' }}>
                <div className="greeting">Beneficiarios</div>
                <Button
                  variant="text"
                  color="primary"
                  onClick={() => editarBeneficiarios(true)}
                >
                  Editar beneficiarios
                </Button>
              </ContainerCard>
              <div>
                {beneficiarios.map(beneficiario => (
                  <div key={beneficiario.id} style={{ marginBottom: '20px' }}>
                    <div>
                      <strong>Nombre:</strong> {beneficiario.nombre}
                    </div>
                    <div>
                      <strong>Parentesco:</strong>{' '}
                      {parentescoOptions
                        .find(
                          parentesco =>
                            parentesco.id === beneficiario.parentescoId,
                        )
                        .nombre.toLowerCase()}
                    </div>
                    <div>
                      <strong>Fecha de nacimiento:</strong>{' '}
                      {moment(beneficiario.fechaNacimiento)
                        .locale('es')
                        .format('DD MMMM YYYY')}
                    </div>
                    <div>
                      <strong>Porcentaje asignado:</strong>{' '}
                      {beneficiario.porcentaje}%
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div style={{ width: '100%', marginBottom: '60px' }}>
              <ContainerCard style={{ marginTop: '20px' }}>
                <div className="greeting">Beneficiarios</div>
                {beneficiariosCopy.length !== 0 && (
                  <Button
                    variant="text"
                    color="primary"
                    onClick={() => handleCancelEditBeneficiarios()}
                  >
                    Cancelar
                  </Button>
                )}
              </ContainerCard>
              <BeneficiariosForm
                parentescos={parentescoOptions}
                beneficiarios={beneficiarios}
                setBeneficiariosArray={setBeneficiarios}
                onValidation={handleValidateBeneficiarios}
              />
            </div>
          )}
        </Content>
      )}

      {activeStep === 4 && (
        <DomicilioActual
          clientInfo={clientInfo}
          editAddress={editAddress}
          editAddressStatus={editAddressStatus}
          existAddress={existAddress}
          newPostalCode={newPostalCode}
          setNewPostalCode={setNewPostalCode}
          newCity={newCity}
          setNewCity={setNewCity}
          newState={newState}
          setNewState={setNewState}
          newSuburb={newSuburb}
          setNewSuburb={setNewSuburb}
          suburbsOptions={suburbsOptions}
          newStreet={newStreet}
          setNewStreet={setNewStreet}
          newNumber={newNumber}
          setNewNumber={setNewNumber}
          addressProofFile={addressProofFile}
          addressProofFileName={addressProofFileName}
          setAddressProofFile={setAddressProofFile}
          setAddressProofFileName={setAddressProofFileName}
          requiereComprobanteDom={requiereComprobanteDom.current}
          plazaRequiereComprobanteDom={plazaRequiereComprobanteDom.current}
          maxValidationAttempts={
            numeroIntentosValidacionComprobanteDomicilio.current
          }
          token={token}
          addressFromProof={addressFromProof}
          setAddressFromProof={setAddressFromProof}
          setLoading={setLoadingFull}
          documentoClienteId={documentoClienteId}
        />
      )}

      {activeStep === 5 && (
        <Content>
          <h1>Firmar tu pagaré</h1>
          <ContainerCard>
            <div className="greeting">Firma</div>
          </ContainerCard>
          <div
            style={{
              marginBottom: '20px',
              border: '1px solid #ccc',
              padding: '10px',
              borderRadius: '4px',
            }}
          >
            {getPagareWithVariables()}
          </div>
          <ContainerCanvas>
            <SignatureCanvas
              penColor="black"
              ref={signatureRef}
              onEnd={() => onSignatureEnd()}
              canvasProps={{
                width: 400,
                height: 200,
                className: 'sigCanvas',
              }}
            />
          </ContainerCanvas>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginBottom: '50px',
            }}
          >
            <Button color="primary" onClick={clearSignature}>
              Reiniciar
            </Button>
          </div>
        </Content>
      )}

      {activeStep === 6 && (
        <Content>
          <h1>Identificación oficial</h1>
          <ContainerCard>
            <div className="greeting">
              Necesitamos el frente y reverso de su INE
            </div>
          </ContainerCard>
          {alreadyIdCaptureError && (
            <div className="greeting">
              Ha sucedido un error al momento de identificar su INE. Intentelo
              de nuevo.
            </div>
          )}
          {currentlyIdCapture && <div id="id_component"></div>}
          {currentlyIdCapture && <IdComponent />}

          {!currentlyIdCapture &&
            !ineFrente &&
            !ineReverso &&
            !ineFrontUrl &&
            !ineBackUrl && (
              <>
                <ImageContainer onClick={() => prepareForNubariumSDK()}>
                  <DocumentContainer>
                    <ImageDocumentContainer>
                      <CameraIcon color="#994878" />
                    </ImageDocumentContainer>
                  </DocumentContainer>
                </ImageContainer>
                <DocumentText>Capturar Identificacion</DocumentText>
              </>
            )}
          {(ineFrente || ineFrontUrl) && !currentlyIdCapture && (
            <>
              <ImageContainer
                id={!isIOS ? 'ineFrenteDiv' : ''}
                onClick={() => prepareForNubariumSDK()}
              >
                {ineFrente ? (
                  <DocumentContainer>
                    <ImageDocumentContainer>
                      <>
                        <DistributorImage
                          alt="ineFrente.png"
                          src={`data:image/jpeg;base64,${ineFrente}`}
                        />
                      </>
                    </ImageDocumentContainer>
                  </DocumentContainer>
                ) : (
                  <DocumentContainer>
                    <ImageDocumentContainer>
                      <>
                        <DistributorImage
                          alt="ineFrente.png"
                          src={ineFrontUrl}
                        />
                      </>
                    </ImageDocumentContainer>
                  </DocumentContainer>
                )}
              </ImageContainer>
              <DocumentText>Frente</DocumentText>
            </>
          )}
          {(ineReverso || ineBackUrl) && !currentlyIdCapture && (
            <>
              <ImageContainer
                onClick={() => prepareForNubariumSDK()}
                id={!isIOS ? 'ineReversoDiv' : ''}
              >
                {ineReverso ? (
                  <DocumentContainer>
                    <ImageDocumentContainer>
                      <>
                        <DistributorImage
                          alt="ineReverso.png"
                          src={`data:image/jpeg;base64,${ineReverso}`}
                        />
                      </>
                    </ImageDocumentContainer>
                  </DocumentContainer>
                ) : (
                  <DocumentContainer>
                    <ImageDocumentContainer>
                      <>
                        <DistributorImage
                          alt="ineReverso.png"
                          src={ineBackUrl}
                        />
                      </>
                    </ImageDocumentContainer>
                  </DocumentContainer>
                )}
              </ImageContainer>
              <DocumentText>Reverso</DocumentText>
            </>
          )}
        </Content>
      )}

      {activeStep === 7 && !voucherRedeemed ? (
        <Content>
          <h1>Validación de identidad</h1>
          {currentlyFaceCapture && showIdentityValidator && <FaceComponent />}
          {currentlyFaceCapture && showIdentityValidator && (
            <div id="face_component"></div>
          )}

          {!currentlyFaceCapture && !selfie && (
            <>
              {showIdentityValidator ? (
                <>
                  <ImageContainer onClick={() => setCurrentlyFaceCapture(true)}>
                    <DocumentContainer>
                      <ImageDocumentContainer>
                        <CameraIcon color="#994878" />
                      </ImageDocumentContainer>
                    </DocumentContainer>
                  </ImageContainer>
                  <DocumentText>Capturar Selfie</DocumentText>
                </>
              ) : (
                <>
                  <ImageContainer onClick={() => console.log()}>
                    <DocumentContainer>
                      <ImageDocumentContainer>
                        <CheckIcon color="#994878" />
                      </ImageDocumentContainer>
                    </DocumentContainer>
                  </ImageContainer>
                  <DocumentText>Identidad validada</DocumentText>
                </>
              )}
            </>
          )}

          {!currentlyFaceCapture && selfie && (
            <>
              {errorFaceCapture ? (
                <>
                  <ImageContainer
                    onError={errorFaceCapture}
                    onClick={() => setCurrentlyFaceCapture(true)}
                  >
                    <DocumentContainer>
                      <ImageDocumentContainer>
                        <>
                          <DistributorImage
                            alt="ineFrente.png"
                            src={`data:image/jpeg;base64,${selfie}`}
                          />
                        </>
                      </ImageDocumentContainer>
                    </DocumentContainer>
                  </ImageContainer>
                  <DocumentText>{errorSelfie}</DocumentText>
                </>
              ) : (
                <>
                  <ImageContainer>
                    <DocumentContainer>
                      <ImageDocumentContainer>
                        <>
                          <DistributorImage
                            alt="ineFrente.png"
                            src={`data:image/jpeg;base64,${selfie}`}
                          />
                        </>
                      </ImageDocumentContainer>
                    </DocumentContainer>
                  </ImageContainer>
                  <DocumentText>{successSelfie}</DocumentText>
                </>
              )}
            </>
          )}

          {!currentlyFaceCapture && errorSelfie && (
            <>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setCurrentlyFaceCapture(true)}
                style={{ marginTop: 12 }}
              >
                Reintentar selfie
              </Button>
            </>
          )}

          {/* NOTE: Might Delete */}
          {validationAttempt <= identityValidationAttempts && (
            <ContentTerms>
              <FormControlLabel
                control={<Checkbox name="accept" color="primary" />}
                // label="Aceptas términos y condiciones."
                className="accept-check"
                onChange={event => setTermsAgreed(event.target.checked)}
              />
              <Button onClick={handleTermsAgreedOpen}>
                Acepto términos y condiciones.
              </Button>
            </ContentTerms>
          )}

          {/* NOTE: Might Delete */}
          {/* <Menu */}
          {/*   id="picture-menu" */}
          {/*   anchorEl={anchorEl} */}
          {/*   keepMounted */}
          {/*   open={Boolean(anchorEl)} */}
          {/*   onClose={handleCloseMenu} */}
          {/* > */}
          {/*   <MenuItem onClick={handleOpenFileInput}>Galería</MenuItem> */}
          {/*   <MenuItem onClick={handleOpenCamera}>Cámara</MenuItem> */}
          {/* </Menu> */}

          {/* NOTE: Might Delete */}
          {/* <Input */}
          {/*   ref={filesRef} */}
          {/*   type="file" */}
          {/*   value="" */}
          {/*   onChange={handleChangeFiles} */}
          {/*   accept=".png, .jpg, .jpeg" */}
          {/* /> */}

          {/* NOTE: Might Delete */}
          {/* <Dialog open={cameraOpen} onClose={handleCloseCamera} maxWidth="sm"> */}
          {/*   <IconButton */}
          {/*     style={{ position: 'absolute', top: 16, right: 16, zIndex: 1 }} */}
          {/*     onClick={handleCloseCamera} */}
          {/*   > */}
          {/*     <CloseIcon /> */}
          {/*   </IconButton> */}
          {/*   {!cameraStarted && <LoadingLabel>Abriendo cámara...</LoadingLabel>} */}
          {/*   <Camera */}
          {/*     idealFacingMode={FACING_MODES.USER} */}
          {/*     isImageMirror */}
          {/*     idealResolution={isMobile ? { width: 640, height: 720 } : {}} */}
          {/*     isMaxResolution={false} */}
          {/*     isSilentMode={false} */}
          {/*     isFullscreen={false} */}
          {/*     sizeFactor={1} */}
          {/*     imageType={IMAGE_TYPES.JPG} */}
          {/*     onTakePhoto={handlePhotoTook} */}
          {/*     onCameraStart={() => { */}
          {/*       setCameraStarted(true); */}
          {/*     }} */}
          {/*   /> */}
          {/* </Dialog> */}

          {/* NOTE: Might Delete */}
          <Snackbar
            open={Boolean(successText)}
            autoHideDuration={6000}
            onClose={() => setSuccessText('')}
          >
            <Alert onClose={() => setSuccessText('')} severity="success">
              {successText}
            </Alert>
          </Snackbar>

          {/* NOTE: Might Delete */}
          <Snackbar
            open={Boolean(errorText)}
            autoHideDuration={6000}
            onClose={() => setErrorText('')}
          >
            <Alert onClose={() => setErrorText('')} severity="error">
              {errorText}
            </Alert>
          </Snackbar>
        </Content>
      ) : null}

      {voucherRedeemed && (
        <Content>
          <h1>¡Gracias por tu preferencia!</h1>
          <div className="greeting">{`Listo, ${get(
            clientInfo,
            'cliente.nombreCompleto',
            '',
          )}!`}</div>
          <div className="instructions">{valeCanjeado}</div>
        </Content>
      )}

      {startExchange && (
        <>
          {!voucherRedeemed && (
            <MobileStepper
              variant="dots"
              steps={7}
              activeStep={activeStep}
              nextButton={
                <>
                  {activeStep === 7 ? (
                    <Button
                      size="medium"
                      variant="contained"
                      color="primary"
                      onClick={() => handleCanjeVale()}
                      disabled={disabled}
                      style={{ textTransform: 'none' }}
                    >
                      Canjear
                    </Button>
                  ) : (
                    <Button
                      size="small"
                      onClick={handleNext}
                      color="primary"
                      disabled={isNextDisabled}
                      style={{ textTransform: 'none' }}
                    >
                      Siguiente
                    </Button>
                  )}
                </>
              }
              backButton={
                <Button
                  size="small"
                  onClick={handleBack}
                  color="primary"
                  disabled={activeStep === 0}
                  style={{ textTransform: 'none' }}
                >
                  Atrás
                </Button>
              }
            />
          )}
        </>
      )}

      {loadingFull && <Loader />}
      <Dialog
        open={termsAgreedOpen}
        onClose={handleTermsAgreedClose}
        maxWidth="sm"
      >
        <IconButton
          style={{ position: 'absolute', top: 16, right: 16, zIndex: 1 }}
          onClick={handleTermsAgreedClose}
        >
          <CloseIcon />
        </IconButton>
        <ContainerDialogTerms>
          <div>{parse(termsAndConditions, options)}</div>
        </ContainerDialogTerms>
      </Dialog>
    </ContainerGeneral>
  );
};

export default CanjeValeDigital;
